export const PAGE_LENGTH = 100;
export const ITEMS_PER_PAGE = 25;
export const CURRENT_PAGE = 1;
export const PAGE_SIZE_OPTIONS = [10,25,50,100];

export const DASHBOARD_ITEMS_PER_PAGE = 5;
export const DASHBOARD_CURRENT_PAGE = 1;
export const DASHBOARD_PAGE_SIZE_OPTIONS = [5,10,25];